import React from "react";
import "./Captcha.scss";
import Turnstile, { useTurnstile } from "react-turnstile";

const Captcha = (props) => {
  const turnstile = useTurnstile();

  function onExpired() {
    turnstile.reset();
  }

  return (
    <div className="captcha">
      <Turnstile
        sitekey={props.sitekey}
        // onError={MessageServices.ShowError(
        //   "Ocorreu um erro na validação do CAPTCHA. Por favor, entre em contato com o suporte.",
        // )}
        // onExpired={onExpired}
        onVerify={(token) => {
          props.onVerify(token);
        }}
      />
    </div>
  );
};

Captcha.defaultProps = {
  sitekey: "0x4AAAAAABC6x_zBJGBeMduh",
  onError: () => null,
  onVerify: () => null,
};

export default Captcha;
